module.exports = __webpack_public_path__ + "img/dummy-testi.fe3567f1.png";